import { render, staticRenderFns } from "./hotProductConfig1.vue?vue&type=template&id=7efb38c2&scoped=true"
import script from "./hotProductConfig1.vue?vue&type=script&lang=js"
export * from "./hotProductConfig1.vue?vue&type=script&lang=js"
import style0 from "./hotProductConfig1.vue?vue&type=style&index=0&id=7efb38c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efb38c2",
  null
  
)

export default component.exports